export class AddressDataForm {
    addressId: number;
    firstName: string;
    lastName: string;
    mobileNo: string;
    userName: string;
    userDetailsId: number;
    address: String;
    locality: String;
    city: String;
    state: String;
    zipCode: String;
    country: String;
}